import * as React from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import PropTypes from 'prop-types';

PageToggleButton.propTypes = {
  rowsPerPageOptions: PropTypes.map,
  perPageCount: PropTypes.number,
  rowsPerPage: PropTypes.func,
  filterInUse: PropTypes.bool
};

export default function PageToggleButton({rowsPerPageOptions, perPageCount, rowsPerPage, filterInUse}) {
  const [perPage, setRowsPerPage] = React.useState(perPageCount);

  const handleChange = (event, perPage) => {
    setRowsPerPage(perPage);
    rowsPerPage(perPage);
  };
  return (
    <ToggleButtonGroup disabled = {filterInUse}
      color="primary"
      value={perPage}
      exclusive
      onChange={handleChange}
      aria-label="Platform"
      sx={{
        ".MuiToggleButtonGroup-grouped": {
            fontSize: '16px !important',
            color: '#000000DE',
            height: '35px',
            marginTop: '15px',
          },
        ".Mui-selected": {
          backgroundColor: '#135d87 !important',
          color:'#fff !important',
          fontSize: '16px !important',
         }
    }}
    >
    {
    rowsPerPageOptions.map(bl => (
        <ToggleButton  key={bl}
        value={bl}>{bl}</ToggleButton>)
    )
    } 
    </ToggleButtonGroup>
  );
}